import React from 'react';
import './style.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import RUG from "react-upload-gallery";
// , { DragArea, DropArea, Card, List }

import UserContext from 'store/UserContext';



class MultipleImages extends React.Component {
    static contextType = UserContext;
    customRequest = ({ uid, loaded,file, onProgress }) => {
        
        const onUploadProgress = () => {
            onProgress(uid, Math.round(loaded / file * 10));
        };
        onUploadProgress();
        
        return {
            abort() {
            }
        };
    }
    
    render() {
        //console.log("MultipleImages RENDER; this.props.savedMultiImages",this.props.savedMultiImages);
        let max_images = 8;
        if (this.props.max_images) {
            max_images = this.props.max_images;
        }
        
        let tmp_filenames = this.props.savedMultiImages.sort((a, b) => a.name.localeCompare(b.name)).map((item) => item.name);
        let rug_footer = <span style={{ fontSize: "smaller" }}>Current filenames: {tmp_filenames.join(", ")}</span>;
        
        return (
            <div className="container pad-bot20">
                <Row >
                    <Col lg={12} className="coverphoto">
                        <div >
                            <div className="pad-tb30 cover-border">
                                <h3>Additional Background Images</h3>
                                <p>
                                    Displayed at the top of the page. Wide format (4:1 ratio) recommended. Maximum {max_images} images.<br/>
                                    Uploaded image will automatically be cropped and displayed with a gradient over the left side.<br/>
                                    To order images, please name image files in desired alphabetical order (eg "0010.jpg", "0020.jpg", etc.).
                                </p>
                            </div>
                        </div>
                        {
                                    this.props.imageValidator === true ?
                                        <p className="PKTitleCollision upload-images-collision">Please remove the below images then continue to upload new images.</p>
                                        :
                                        null
                                }
                        <div className="multiple-images add-multi-images">
                        <div className="Upload form-card">
                                <div className="Upload-header">
                                    {/* <img src={logo} className="Upload-logo" alt="logo"/> */}
                                    <h3 style={{ marginTop: "-2px" }}>Add Additional Background Images</h3>
                                </div>
                                {/* {ImageUploadLoader === true ?
                                        <p className="PKTitleSuccess">Uploading Slides</p>
                                        :
                                        null
                                }     */}
                               
                                   {this.props.uploadErrorMessage} 
                                   
                                    <RUG
                                        className={this.context.theme}
                                        rules={{
                                            limit: max_images
                                        }}
                                        type="card"
                                        initialState={this.props.savedMultiImages}
                                        // rules={{ limit: 8 }}
                                        accept={['jpg', 'jpeg', 'png', 'gif']}
                                        // action="/api/upload" // upload route
                                        sorting={false}
                                        
                                        source={response => response.source}
                                        
                                        onChange={this.props.onChangeImages}
                                        
                                        //onSuccess={this.props.onSuccess}
                                        
                                        customRequest={this.customRequest}
                                        //customRequest={this.props.customRequest}
                                        footer={() => rug_footer}
                                        //footer={() => {
                                        //    if (this.props.footer) {
                                        //        return this.props.footer;
                                        //    } else {
                                        //        return "";
                                        //    }
                                        //}}
                                    >
                                    </RUG>
                                   {/* {(this.props.savedMultiImages.length === 0 ||  this.props.multipleImagesArr && this.props.multipleImagesArr.length === 0) &&
                                    <div className="no-images-data"><p>No Uploaded Images</p></div> }   */}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
export default MultipleImages;